import React, { useEffect } from 'react'
import PdaTitle from '../../component/common/PdaTitle'
import LogoDark from '../../component/common/LogoDark'
import { PdaMenuItem } from '../../types/common'
import MenuLink from '../../component/common/MenuLink'
import { useCounter } from 'primereact/hooks'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { tokens } from '../../locales/tokens'
import { getBrand } from '../../utils/tenant'

const PdaMenu = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const { t } = useTranslation()

    const menus: PdaMenuItem[] = [
        {
            name: t(tokens.inbound.incoming_management),
            uri: '/inbound',
        },
        {
            name: t(tokens.outbound.management),
            uri: '/outbound',
        },
        {
            name: t(tokens.inventory.inventory_control),
            uri: '/inventory',
        },
        {
            name: t(tokens.common.product_inquiry),
            uri: '/goods',
        },
    ]

    const { count, increment, reset } = useCounter(0, { min: 0, max: 8, step: 1 })

    // 클릭 시 카운트 증가
    const onClickLogOut = () => {
        increment()
    }

    // count가 8이 되었을 때 로그아웃 실행
    useEffect(() => {
        if (count === 8) {
            reset()
            localStorage.removeItem('rdmsToken')
            localStorage.removeItem('rdmsMyIp')
            navigate('/login')
        }
    }, [count, reset, navigate])

    // 뒤로가기 막기
    useEffect(() => {
        const handlePopState = (event: PopStateEvent) => {
            window.history.pushState(null, '', window.location.href)
        }
        if (location.pathname === '/') {
            window.history.pushState(null, '', window.location.href)
            window.addEventListener('popstate', handlePopState)
        }
        return () => {
            window.removeEventListener('popstate', handlePopState)
        }
    }, [location.pathname])

    return (
        <>
            <div onClick={onClickLogOut}>
                <PdaTitle title={getBrand().appTitle} home />
            </div>
            <LogoDark />
            <MenuLink items={menus} />
        </>
    )
}

export default PdaMenu
